import { ServiceLayerModel } from './service-layer.model';

// Future properties: requestVertexNormals (additional lighting information), credit
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface TerrainLayerModel extends ServiceLayerModel {

}
